let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lLYMQ")).then(() => parcelRequire('eNug6'));